
import axios from 'axios';
import cookie from 'js-cookie';

const util = {};
let url = '/';

util.baseURL = url;

util.ajax = axios.create({
  baseURL: url,
  withCredentials: true,
  timeout: 60000,
});

// 添加请求拦截器
util.ajax.interceptors.request.use((config) => {
  const copyConfig = config;
  const token = `/${cookie.get('_app_token_')}`;

  if (
    copyConfig.url.lastIndexOf('servlet') === -1 &&
    copyConfig.url.lastIndexOf('export') === -1 &&
    copyConfig.url.lastIndexOf('app/rest/public/email') === -1 &&
    copyConfig.url.lastIndexOf('app/rest/public/partner') === -1 &&
    copyConfig.url.lastIndexOf('push_backend') === -1 &&
    copyConfig.url.lastIndexOf('subscribe') === -1 &&
    config.url.lastIndexOf('smsauthquery') === -1 &&
    config.url.lastIndexOf('app/rest/env_router/get') === -1) {
    if (copyConfig.url.lastIndexOf('?') === -1) {
      copyConfig.url += token;
    } else {
      const link = copyConfig.url;
      const queryString = link.substring(link.lastIndexOf('?'));
      copyConfig.url = link.substring(0, link.lastIndexOf('?')) + token + queryString;
    }
  }

  if (copyConfig.url.lastIndexOf('app/rest/data.json/query') !== -1) {
    if (copyConfig.url.lastIndexOf('?') === -1) {
      copyConfig.url += `?_g=${copyConfig.data.groupby}&_m=${copyConfig.data.metrics.join(',')}`;
    }
  }
  if (copyConfig.url.lastIndexOf('/app/indicator/query') !== -1) {
    if (copyConfig.url.lastIndexOf('?') === -1) {
      copyConfig.url += `?_g=${copyConfig.data.groupBy}&_m=${copyConfig.data.metrics}`;
    }
  }
  return copyConfig;
}, (error) => {
  const result = Promise.reject(error);
  return result;
});

// 添加响应拦截器
util.ajax.interceptors.response.use((response) => {
  let result = response.data;
  if (response.data && typeof response.data === 'object' && response.data.result) {
    result = response.data.result
  }
  return result;
}, (error) => {
  const statusCode = error.response && error.response.status;
  if (statusCode === 440 || statusCode === 441 || statusCode === 442) {
    window.location.href = `${window.location.origin}${error.response.data}`;
  } else if (statusCode === 420) {
    if (window.location.host === 'www.talkingdata.com') {
      cookie.remove('tdppt');
      window.location.href = `${window.location.origin}/app/newVersion`;
    } else {
      const msg = {
        eventType: 'msg-error-420',
        eventInfo: {},
      };
      window.postMessage(msg, '*');
    }
  }
  return Promise.reject(error);
});


// 日期格式化
// eslint-disable-next-line
Date.prototype.format = function (fmt) { // fmt 自定义格式,如：yy-MM-dd
  let fm = fmt;
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fm)) {
    fm = fm.replace(RegExp.$1, (this.getFullYear().toString()).substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fm)) {
      fm = fm.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
    }
  });
  return fm;
};

export default util;
